/*
 * Copyright (c) 2016-2018 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

// @TODO The top two are not used now, which is probably a performance drag that was broken along the way.
// There was a previous pattern to hide everything to do computation then display, for Firefox, needs revisiting.
export const NO_LAYOUT_CLASS = 'datagrid-no-layout';
export const COMPUTE_WIDTH_CLASS = 'datagrid-computing-columns-width';
export const STRICT_WIDTH_CLASS = 'datagrid-fixed-width';
export const HIDDEN_COLUMN_CLASS = 'datagrid-hidden-column';
